import { AppShell, Flex } from '@mantine/core';
import { Drawer } from '@zorro/design-system/v2/Drawer';
import { ZorroLogo } from '@zorro/shared/assets';
import { Stack, brand } from '@zorro/web/design-system';
import { useMobileDetector } from '@zorro/web/ui-utils';
import { ReactNode } from 'react';

import { useAppLayout } from './AppLayoutContext';

type Props = {
  children: ReactNode;
};

export const AppLayoutSidebar = ({ children }: Props) => {
  const { isSidebarOpen, toggleSidebar } = useAppLayout();
  const { isMobile } = useMobileDetector();

  if (isMobile) {
    return (
      <Drawer
        size="20rem"
        bg={brand.zorroPlum200}
        onClose={toggleSidebar}
        opened={isSidebarOpen}
        closeButtonPosition="left"
        title={
          <Flex justify="flex-start">
            <ZorroLogo />
          </Flex>
        }
        position="left"
      >
        <Stack mt="sm">{children}</Stack>
      </Drawer>
    );
  }

  return (
    <AppShell.Navbar bg="transparent">
      <Stack>{children}</Stack>
    </AppShell.Navbar>
  );
};
